import React from "react";
import {
  TankContainer,
  TankBody,
  Liquid,
  TankLabel,
  GaugeWrapper,
  Wave,
  InfoTextWrapper,
  InfoText,
  CenterWrapper
} from "./style";

const TankGauge = ({ value, max, min, size, shape }) => {
  const percentage = Math.min(Math.max(value / max, 0), 1) * 100;
  const height = `${percentage}%`;

  const volumeLitros = value.toFixed(2);

  return (
    <CenterWrapper>
      <GaugeWrapper size={size}>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <TankLabel size={size}>
              {volumeLitros} / {max}
            </TankLabel>
            <TankContainer size={size}>
              <TankBody>
                <Liquid height={height}>
                  <Wave />
                </Liquid>
              </TankBody>
            </TankContainer>
            <span style={{ marginTop: 8, fontWeight: "bold" }}>{shape}</span>
          </div>

          <InfoTextWrapper>
            <InfoText>TOTAL: {max} L</InfoText>
            <InfoText>MÍNIMO: {min} L</InfoText>
            <InfoText>VOLUME: {volumeLitros} L</InfoText>
          </InfoTextWrapper>
        </div>
      </GaugeWrapper>
    </CenterWrapper>
  );
};

export default TankGauge;
